import IAM_LOGO_B64 from "../assets/logoData";

export default function IamLogo({ height = 40, style = {} }) {
  return (
    <img
      src={IAM_LOGO_B64}
      alt="IAM Business Group"
      style={{ height, width: "auto", objectFit: "contain", ...style }}
    />
  );
}
